export enum ConnectedService {
  UmojoAnalytics = 'f9526e66-9a3d-4bc8-8f11-8fb45867b61d',
  NexCity = 'b430eacb-82cb-4143-84fa-0db02d815c02',
  NexPark = '2858ee66-c17e-4512-92ee-452d93c1b995',
  NexResponse = '6dae8f3e-bbc4-44b3-9335-c4d8aff1aed4',
}

export enum ConnectedServiceEnum {
    UmojoAnalytics = 1,
    NexCity = 2,
    NexPark = 3,
    NexResponse = 4,
}
